import { useEffect, useState } from 'react';

import { fetchReliveOptions } from 'api/homelesses';
import { ReliveOptions } from 'types';

const useReliveOptions = (memberId: number | null | undefined, enabled: boolean) => {
    const [reliveOptions, setReliveOptions] = useState<ReliveOptions | null>(null);
    const [isFetchingReliveOptions, setIsFetchingReliveOptions] = useState(enabled);
    const [reliveOptionsError, setReliveOptionsError] = useState(false);

    useEffect(() => {
        if (!enabled || !memberId) {
            setReliveOptions(null);
            setIsFetchingReliveOptions(false);
            setReliveOptionsError(false);
            return;
        }

        let cancelled = false;

        const fetchData = async () => {
            setIsFetchingReliveOptions(true);
            setReliveOptionsError(false);

            try {
                const options = await fetchReliveOptions(memberId);
                if (cancelled) return;
                setReliveOptions(options);
            } catch (error) {
                console.error('Error fetching relive options:', error);
                if (!cancelled) {
                    setReliveOptions(null);
                    setReliveOptionsError(true);
                }
            } finally {
                if (!cancelled) {
                    setIsFetchingReliveOptions(false);
                }
            }
        };

        fetchData();

        return () => {
            cancelled = true;
        };
    }, [memberId, enabled]);

    return { reliveOptions, isFetchingReliveOptions, reliveOptionsError };
};

export default useReliveOptions;
